export default "/_next/static/images/91cef30eef264831fb65ab71a2bb8ef9.png";